import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import './Footer.css';
import theme from '../theme';
import Typography from '@mui/material/Typography/Typography';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="footer mt-auto py-3" style={{ backgroundColor: theme.palette.primary.main, color: "white" }}>
      <Container>
        <Row>
          <Col className="text-center">
            <img alt="footer-logo" src="../assets/images/logo.svg" className={"footer-logo"} />
            <Typography fontWeight={100}>{t('Voice as a Biomarker of Health')}</Typography>
            <p>
              &copy; Weill Cornell Medicine - {t('Version')} 26.2.0 - {' '}
              <a href="https://b2ai-voice.org/contact-us/" target="_blank" rel="noreferrer">{t('Contact us')}</a> -{' '}
              <a href="https://b2ai-voice.org/terms-and-conditions" target="_blank" rel="noreferrer">{t('Terms of use')}</a>
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
